var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointMessageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 101,
    viewBox: "0 0 260 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_594_5211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.5,
    y: -54,
    width: 341,
    height: 212,
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.5,
    y: 34,
    width: 341,
    height: 7,
    fill: "#1F282C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 79,
    width: 211,
    height: 7,
    fill: "#1F282C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 208,
    width: 174,
    height: 7,
    transform: "rotate(-90 89.5 208)",
    fill: "#1F282C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 41,
    width: 174,
    height: 7,
    transform: "rotate(-90 50.5 41)",
    fill: "#1F282C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 208,
    width: 174,
    height: 7,
    transform: "rotate(-90 242.5 208)",
    fill: "#1F282C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 41,
    width: 174,
    height: 7,
    transform: "rotate(-90 184.5 41)",
    fill: "#1F282C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 58,
    rx: 9,
    ry: 4.5,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 45H126V58C126 58.2652 125.895 58.5196 125.707 58.7071C125.52 58.8946 125.265 59 125 59H124C123.735 59 123.48 58.8946 123.293 58.7071C123.105 58.5196 123 58.2652 123 58V45Z",
    fill: "#3CA4A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5 46C131.956 46 138 39.9558 138 32.5C138 25.0442 131.956 19 124.5 19C117.044 19 111 25.0442 111 32.5C111 39.9558 117.044 46 124.5 46Z",
    fill: "#5ACBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.759 39.9992H121.6V39.509C121.6 37.601 121.593 34.2748 121.591 33.1418L121.609 32.8176C120.318 32.1528 119.211 31.181 118.385 29.9875C117.559 28.794 117.039 27.4157 116.871 25.9738C116.838 25.7981 116.845 25.6174 116.89 25.4445C116.935 25.2717 117.018 25.111 117.133 24.9738C117.253 24.8297 117.403 24.7133 117.572 24.632C117.741 24.5508 117.925 24.5068 118.113 24.5031C118.347 24.4982 118.573 24.5835 118.746 24.7414C118.918 24.8993 119.023 25.1175 119.039 25.3508C119.257 27.2781 120.227 29.0415 121.739 30.257V30.2258C122.733 30.0427 123.742 29.9512 124.753 29.9514C125.739 29.8965 126.726 30.0619 127.64 30.4367L127.647 30.4494L127.655 30.4611C127.76 30.501 127.858 30.557 127.946 30.6272C128.787 31.3662 129.438 32.2957 129.846 33.3381C129.876 33.4061 129.907 33.4751 129.94 33.5471L129.951 33.5695C130.272 34.1629 130.473 34.8141 130.542 35.4856C130.462 36.1183 130.24 36.7251 129.891 37.259C129.832 37.366 129.776 37.4696 129.725 37.5676C129.258 38.5133 128.585 39.3431 127.756 39.9943L127.759 39.9992ZM127.439 33.1184L127.449 37.3967C127.65 37.1171 127.833 36.8255 127.999 36.5236C128.159 36.2306 128.294 35.9236 128.431 35.6096C128.454 35.5546 128.471 35.5103 128.49 35.4523C128.27 34.6218 127.915 33.8332 127.439 33.1184ZM124.572 29.6115C124.134 29.6281 123.7 29.5139 123.328 29.2824C122.955 29.051 122.66 28.713 122.481 28.3127C122.302 27.9124 122.246 27.4684 122.321 27.0363C122.397 26.6043 122.6 26.2039 122.904 25.8879C123.208 25.5719 123.599 25.3538 124.028 25.2619C124.457 25.1701 124.904 25.2085 125.31 25.3723C125.717 25.5361 126.066 25.8185 126.312 26.1818C126.557 26.5452 126.688 26.9737 126.689 27.4123C126.698 27.984 126.481 28.5357 126.084 28.9475C125.687 29.3592 125.144 29.5968 124.572 29.6086V29.6115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_594_5211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointMessageDark);
export default __webpack_public_path__ + "static/media/point-message-dark.d7dbf194920e4f1c30c072d5e23979f9.svg";
export { ForwardRef as ReactComponent };